export enum PartViewMode {
  EDIT,
  UPDATED,
  CALCULATED,
  CHECKOUT,
  READ_ONLY,
  ADAPT
}
